import { wa } from "@/lib/site";
import { Reveal } from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";

export default function CTABand({
  title = "Mari Bangun Apparel Anda Bersama Kami",
  subtitle = "Konsultasikan kebutuhan konveksi Anda sekarang. Tim kami siap membantu dari desain sampai pengiriman.",
  buttonLabel = "Konsultasi via WhatsApp",
  waMsg = "Halo HATTORY KONVEKSI, saya ingin memulai konsultasi untuk kebutuhan apparel saya.",
}) {
  return (
    <section className="mx-auto max-w-7xl px-6 py-16 md:px-12 md:py-24" data-testid="cta-band">
      <Reveal className="relative overflow-hidden rounded-3xl bg-navy px-8 py-16 md:px-16 md:py-24">
        <div className="grain absolute inset-0" />
        <div className="pointer-events-none absolute -right-10 -top-16 select-none text-[16vw] font-black leading-none text-white/[0.05]">H</div>
        <div className="relative z-10 max-w-2xl">
          <h2 className="text-4xl font-black leading-tight tracking-tight text-white md:text-5xl">
            {title}
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-silver">{subtitle}</p>
          <a
            href={wa(waMsg)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-band-btn"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 font-medium text-navy transition-transform duration-300 hover:scale-105 active:scale-95"
          >
            {buttonLabel} <ArrowUpRight className="h-5 w-5" />
          </a>
        </div>
      </Reveal>
    </section>
  );
}
